import { FC } from 'react';
import { Link } from 'react-router-dom';
import { HStack } from '@chakra-ui/react';

import SunshineCard from 'components/_core/SunshineCard';
import SunshineIcon from 'components/_core/SunshineIcon';
import Text from 'components/_core/Text';
import { usePostOnboardingAccountSetupContext } from 'features/PostOnboardingAccountSetup/context';

import AccountSetupCircularProgress from '../AccountSetupCircularProgress';
import locales from './locales';

const AccountSetupBox: FC = () => {
  const { loading, progressLabel, progressValue } =
    usePostOnboardingAccountSetupContext();

  if (loading) {
    return null;
  }

  return (
    <SunshineCard
      as={Link}
      marginBottom="space-24"
      paddingX="space-8"
      to="/account-setup"
    >
      <SunshineCard.Content padding="space-0">
        <HStack gap="space-16">
          <AccountSetupCircularProgress
            progress={progressValue}
            progressLabel={progressLabel}
            size="47.62px"
            textSize="sm"
          />
          <Text
            fontWeight="weight-500"
            lineHeight="20px"
            size="sm"
            variant="primary"
          >
            {locales.title}
            <SunshineIcon
              color="grey.600"
              marginLeft="space-8"
              name="chevron-right"
              size="icon-20"
              verticalAlign="bottom"
            />
          </Text>
        </HStack>
      </SunshineCard.Content>
    </SunshineCard>
  );
};

export default AccountSetupBox;
